/**
 * Feature Slugs from CMS Service
 * These slugs are used to check if features are enabled for the current brand
 */
export const FEATURES = {
  // WhatsApp Messaging Features
  BROADCAST_CAMPAIGN: 'gwx-ai-biz-suite-msg-solns-wapp-bcast',
  SEQUENCE_CAMPAIGN: 'gwx-ai-biz-suite-msg-solns-wapp-seqn',
  CAMPAIGN_MANAGEMENT: 'gwx-ai-biz-suite-msg-solns-wapp-campaign-mgmt',
  CATALOG_PRODUCTS: 'gwx-ai-biz-suite-msg-solns-wapp-catalog-products',
  INBOX: 'gwx-ai-biz-suite-msg-solns-wapp-inbox',
  TEMPLATES: 'gwx-ai-biz-suite-msg-solns-wapp-templates',
  FLOWS: 'gwx-ai-biz-suite-msg-solns-flows-wapp',
  PHONE_NUMBERS: 'gwx-ai-biz-suite-msg-solns-phone-numbers-wapp',
  PAYMENT_CONFIG: 'gwx-ai-biz-suite-msg-solns-payment-config-wapp',
  CALENDAR: 'gwx-ai-biz-suite-msg-solns-calendar-wapp',
  API_ACCESS: 'gwx-ai-biz-suite-msg-solns-api-access-wapp',

  // User Management
  INVITE_USERS: 'gwx-ai-biz-suite-msg-solns-invite-users',

  // CRM Features
  CONTACT_MANAGEMENT: 'gwx-ai-biz-suite-crm-solns-crm-contact-mgmt',
  AUDIENCE_SEGMENTATION: 'gwx-ai-biz-suite-crm-solns-crm-audience-segmentation',
  CUSTOM_ATTRIBUTES: 'gwx-ai-biz-suite-crm-solns-crm-custom-profile-attributes',
  TAGS_LABELS: 'gwx-ai-biz-suite-crm-solns-crm-tags-labels',
};

/**
 * Function Slugs from CMS Service
 * These slugs are used to check if specific functions are enabled for the current brand
 */
export const FUNCTIONS = {
  // Campaign Management Functions
  CAMPAIGN_ENGAGEMENT: 'gwx-ai-biz-suite-msg-solns-wapp-campaign-mgmt-wapp-campaign-engagement',
  CAMPAIGN_AWARENESS: 'gwx-ai-biz-suite-msg-solns-wapp-campaign-mgmt-wapp-campaign-awareness',
  CAMPAIGN_LEADS: 'gwx-ai-biz-suite-msg-solns-wapp-campaign-mgmt-wapp-campaign-leads',
  CAMPAIGN_SALES: 'gwx-ai-biz-suite-msg-solns-wapp-campaign-mgmt-wapp-campaign-sales',

  // Broadcast Functions
  BROADCAST_LIMIT: 'gwx-ai-biz-suite-msg-solns-wapp-bcast-wapp-bcast-limit',
  BROADCAST_SEND_NOW: 'gwx-ai-biz-suite-msg-solns-wapp-bcast-send-now',
  BROADCAST_SEND_LATER: 'gwx-ai-biz-suite-msg-solns-wapp-bcast-send-later',
  BROADCAST_MARKETING: 'gwx-ai-biz-suite-msg-solns-wapp-bcast-wapp-bcast-mktg-tmpl',
  BROADCAST_UTILITY: 'gwx-ai-biz-suite-msg-solns-wapp-bcast-wapp-bcast-util-tmpl',

  // Sequence Functions
  SEQUENCE_BROADCAST_TRIGGER: 'gwx-ai-biz-suite-msg-solns-wapp-seqn-wapp-seq-bcast-trigger',
  SEQUENCE_QR_TRIGGER: 'gwx-ai-biz-suite-msg-solns-wapp-seqn-wapp-seq-qr-trigger',
  SEQUENCE_KEYWORD_TRIGGER: 'gwx-ai-biz-suite-msg-solns-wapp-seqn-wapp-seq-kw-trigger-count',
  SEQUENCE_KEYWORD_LIMIT: 'gwx-ai-biz-suite-msg-solns-wapp-seqn-wapp-seq-kw-limit',
  SEQUENCE_API_TRIGGER: 'gwx-ai-biz-suite-msg-solns-wapp-seqn-wapp-seq-api-trigger',
  SEQUENCE_MARKETING: 'gwx-ai-biz-suite-msg-solns-wapp-seqn-wapp-seq-mktg-tmpl',
  SEQUENCE_UTILITY: 'gwx-ai-biz-suite-msg-solns-wapp-seqn-wapp-seq-util-tmpl',
  SEQUENCE_NODE_COUNT: 'gwx-ai-biz-suite-msg-solns-wapp-seqn-wapp-seq-node-count',
  SEQUENCE_AUTO_ASSIGN: 'gwx-ai-biz-suite-msg-solns-wapp-seqn-wapp-seq-auto-assign',
  SEQUENCE_INAPP_PREVIEW: 'gwx-ai-biz-suite-msg-solns-wapp-seqn-wapp-seq-inapp-preview',
  SEQUENCE_WHATSAPP_PREVIEW: 'gwx-ai-biz-suite-msg-solns-wapp-seqn-wapp-seq-whatsapp-preview',
  SEQUENCE_TIME_DELAY: 'gwx-ai-biz-suite-msg-solns-wapp-seqn-wapp-seq-time-delay',
  SEQUENCE_MESSAGE_TYPES: 'gwx-ai-biz-suite-msg-solns-wapp-seqn-wapp-seq-msg-types',

  // Catalog Functions
  CATALOG_ITEM_CREATE: 'gwx-ai-biz-suite-msg-solns-wapp-catalog-products-wapp-catalog-item-create',
  CATALOG_LIMIT: 'gwx-ai-biz-suite-msg-solns-wapp-catalog-products-wapp-catalog-limit',

  // Inbox Functions
  INBOX_CHAT_HISTORY: 'gwx-ai-biz-suite-msg-solns-wapp-inbox-wapp-inbox-chat-history',
  INBOX_MARKETING: 'gwx-ai-biz-suite-msg-solns-wapp-inbox-wapp-inbox-mktg-tmpl',
  INBOX_UTILITY: 'gwx-ai-biz-suite-msg-solns-wapp-inbox-wapp-inbox-util-tmpl',
  INBOX_SEND_PHOTO: 'gwx-ai-biz-suite-msg-solns-wapp-inbox-wapp-inbox-send-photo',
  INBOX_SEND_VIDEO: 'gwx-ai-biz-suite-msg-solns-wapp-inbox-wapp-inbox-send-video',
  INBOX_SEND_DOC: 'gwx-ai-biz-suite-msg-solns-wapp-inbox-wapp-inbox-send-doc',
  INBOX_SEND_AUDIO: 'gwx-ai-biz-suite-msg-solns-wapp-inbox-wapp-inbox-send-audio',
  INBOX_NOTES: 'gwx-ai-biz-suite-msg-solns-wapp-inbox-wapp-inbox-notes',
  INBOX_ATTACHMENTS: 'gwx-ai-biz-suite-msg-solns-wapp-inbox-wapp-inbox-attachments',
  INBOX_QUICK_REPLY: 'gwx-ai-biz-suite-msg-solns-wapp-inbox-wapp-inbox-quick-reply',

  // Templates Functions
  TEMPLATE_MARKETING_CUSTOM: 'gwx-ai-biz-suite-msg-solns-wapp-templates-wapp-tmpl-mktg-custom',
  TEMPLATE_MARKETING_CAROUSEL: 'gwx-ai-biz-suite-msg-solns-wapp-templates-wapp-tmpl-mktg-carousel',
  TEMPLATE_MARKETING_ORDER: 'gwx-ai-biz-suite-msg-solns-wapp-templates-wapp-tmpl-mktg-order',
  TEMPLATE_UTILITY_CUSTOM: 'gwx-ai-biz-suite-msg-solns-wapp-templates-wapp-tmpl-util-custom',
  TEMPLATE_UTILITY_ORDER: 'gwx-ai-biz-suite-msg-solns-wapp-templates-wapp-tmpl-util-order',
  TEMPLATE_AUTH_CODE: 'gwx-ai-biz-suite-msg-solns-wapp-templates-wapp-tmpl-auth-code',

  // Flows Functions
  FLOW_CREATE: 'gwx-ai-biz-suite-msg-solns-flows-wapp-wapp-flow-create',
  FLOW_MARKETING_BUTTON: 'gwx-ai-biz-suite-msg-solns-flows-wapp-wapp-flow-mktg-btn',
  FLOW_UTILITY_BUTTON: 'gwx-ai-biz-suite-msg-solns-flows-wapp-wapp-flow-util-btn',
  FLOW_ANALYTICS: 'gwx-ai-biz-suite-msg-solns-flows-wapp-wapp-flow-analytics',
  FLOW_INTERACTIVE: 'gwx-ai-biz-suite-msg-solns-flows-wapp-wapp-flow-interactive',

  // Phone Functions
  PHONE_EDIT: 'gwx-ai-biz-suite-msg-solns-phone-numbers-wapp-wapp-phone-edit',
  PHONE_LIMIT: 'gwx-ai-biz-suite-msg-solns-phone-numbers-wapp-wapp-phone-limit',

  // Payment Functions
  PAYMENT_ENABLE: 'gwx-ai-biz-suite-msg-solns-payment-config-wapp-wapp-pay-enable',
  PAYMENT_BROADCAST: 'gwx-ai-biz-suite-msg-solns-payment-config-wapp-wapp-pay-broadcast',
  PAYMENT_SEQUENCE: 'gwx-ai-biz-suite-msg-solns-payment-config-wapp-wapp-pay-sequence',
  PAYMENT_INBOX: 'gwx-ai-biz-suite-msg-solns-payment-config-wapp-wapp-pay-inbox',

  // Calendar Functions
  CALENDAR_BROADCAST: 'gwx-ai-biz-suite-msg-solns-calendar-wapp-wapp-cal-broadcast',

  // API Access Functions
  API_MARKETING_CUSTOM: 'gwx-ai-biz-suite-msg-solns-api-access-wapp-wapp-api-mktg-custom',
  API_MARKETING_CAROUSEL: 'gwx-ai-biz-suite-msg-solns-api-access-wapp-wapp-api-mktg-carousel',
  API_MARKETING_ORDER: 'gwx-ai-biz-suite-msg-solns-api-access-wapp-wapp-api-mktg-order',
  API_UTILITY_CUSTOM: 'gwx-ai-biz-suite-msg-solns-api-access-wapp-wapp-api-util-custom',
  API_UTILITY_ORDER: 'gwx-ai-biz-suite-msg-solns-api-access-wapp-wapp-api-util-order',
  API_AUTH_CODE: 'gwx-ai-biz-suite-msg-solns-api-access-wapp-wapp-api-auth-code',
  API_SERVICE_MSG: 'gwx-ai-biz-suite-msg-solns-api-access-wapp-wapp-api-service-msg',

  // Invite Functions
  INVITE_USER_LIMIT: 'gwx-ai-biz-suite-msg-solns-invite-users-wapp-invite-user-limit',

  // CRM Functions
  CRM_CONTACT_LIMIT: 'gwx-ai-biz-suite-crm-solns-crm-contact-mgmt-crm-contact-limit',
  CRM_BULK_EXPORT: 'gwx-ai-biz-suite-crm-solns-crm-contact-mgmt-crm-bulk-export',
  CRM_BULK_EXPORT_LIMIT: 'gwx-ai-biz-suite-crm-solns-crm-contact-mgmt-crm-bulk-export-limit',
  CRM_BULK_UPLOAD: 'gwx-ai-biz-suite-crm-solns-crm-contact-mgmt-crm-bulk-upload',
  CRM_BULK_UPLOAD_LIMIT: 'gwx-ai-biz-suite-crm-solns-crm-contact-mgmt-crm-bulk-upload-limit',
  CRM_FILTERS: 'gwx-ai-biz-suite-crm-solns-crm-contact-mgmt-crm-filters',
  CRM_SEGMENT_LIMIT: 'gwx-ai-biz-suite-crm-solns-crm-audience-segmentation-crm-segment-limit',
  CRM_VERSIONING: 'gwx-ai-biz-suite-crm-solns-crm-audience-segmentation-crm-segment-version',
  CRM_SCOPE_LIMIT: 'gwx-ai-biz-suite-crm-solns-crm-custom-profile-attributes-crm-attr-scope-limit',
  CRM_ATTRIBUTE_LIMIT: 'gwx-ai-biz-suite-crm-solns-crm-custom-profile-attributes-crm-attr-limit',
  CRM_TAG_LIMIT: 'gwx-ai-biz-suite-crm-solns-crm-tags-labels-crm-tags-limit',
  CRM_CUSTOM_TAGS: 'gwx-ai-biz-suite-crm-solns-crm-tags-labels-crm-tags-custom',
};

/**
 * Route to Feature Mapping
 * Maps application routes to their corresponding feature slugs
 * Used for route-level feature gating
 */
export const ROUTE_FEATURE_MAP = {
  '/user/campaign/broadcast': FEATURES.BROADCAST_CAMPAIGN,
  '/user/campaign/sequence': FEATURES.SEQUENCE_CAMPAIGN,
  '/user/campaign': FEATURES.CAMPAIGN_MANAGEMENT,
  '/user/inbox': FEATURES.INBOX,
  '/user/crm': FEATURES.CONTACT_MANAGEMENT,
  '/user/channels/whatsapp-templates': FEATURES.TEMPLATES,
  '/user/channels/whatsapp-flow': FEATURES.FLOWS,
  '/user/channels/whatsapp': FEATURES.PHONE_NUMBERS,
  '/user/channels/payment': FEATURES.PAYMENT_CONFIG,
  '/user/calendar': FEATURES.CALENDAR,
  '/user/products': FEATURES.CATALOG_PRODUCTS,
  '/user/settings/invite': FEATURES.INVITE_USERS,
};

/**
 * Helper function to get feature slug by route path
 * @param {string} path - The route path
 * @returns {string|null} - The feature slug or null if not found
 */
export const getFeatureByRoute = (path) => {
  return ROUTE_FEATURE_MAP[path] || null;
};
